


const UtilsLocalizedString = (lang, territory) => {
var countryLocalized = "";
  switch (lang) {
    case "ar":
     countryLocalized = territory.name_ar !== undefined ? territory.name_ar : territory.name;
      break;
    case "en":
      countryLocalized = territory.name;
      break;
    case "fr":
        countryLocalized = territory.name_fr !== undefined ? territory.name_fr : territory.name;
      break;
    case "ru":
         countryLocalized = territory.name_ru !== undefined ? territory.name_ru : territory.name;
      break;
    case "zh":
         countryLocalized = territory.name_zh !== undefined ? territory.name_zh : territory.name;
      break;
       case "es":
         countryLocalized = territory.name_es !== undefined ? territory.name_es : territory.name;
      break;
    default:
        countryLocalized = territory.name;
  }
 return countryLocalized;
}
export default UtilsLocalizedString;

